/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export const isObject = (item: any) => {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export const mergeDeep = (target: any, ...sources: any[]): any => {
  if (!sources.length) return target;
  const source = sources.shift();
  if (!source) return target;

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
};

export const deepIncludeIn = (target: any, obj: any): boolean => {
  if (!target || !obj) return false;
  if (typeof target !== 'object' || typeof obj !== 'object') return false;
  let result = true;
  const keys = Object.keys(obj);
  for (let k of keys) {
    if (typeof target[k] === 'object' || typeof obj[k] === 'object') {
      if (!deepIncludeIn(target[k], obj[k])) {
        result = false;
        break;
      }
    } else if ((target as any)[k] !== (obj as any)[k]) {
      result = false;
      break;
    }
  }
  return result;
};